if (!customElements.get('product-custom-inputs')) {
  customElements.define(
    'product-custom-inputs',
    class ProductCustomInputs extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.optionNames = JSON.parse(this.dataset.optionNames || '[]');
        this.currentOptions = JSON.parse(this.dataset.initialOptions || '[]');
        this.fields = Array.from(this.querySelectorAll('[data-field]'));

        this.fields.forEach((field) => {
          const input = field.querySelector('input, select');
          if (!input) return;
          const clear = () => this.setFieldError(field, false);
          input.addEventListener('input', clear);
          input.addEventListener('change', clear);
        });

        this.onSubmitCapture = (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.formId) return;
          if (!this.validate()) {
            event.preventDefault();
            event.stopPropagation();
          }
        };
        // Dawn の product-form は form 要素自身の submit リスナーで fetch 送信するため、
        // それより先に走る document のキャプチャ段階で検証し、不正時は伝播ごと止める
        document.addEventListener('submit', this.onSubmitCapture, true);

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.section) return;
            const variant = event.data.variant;
            if (!variant || !variant.options) return;
            this.currentOptions = variant.options;
            this.applyVisibility();
          });
        }

        this.applyVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmitCapture, true);
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      applyVisibility() {
        this.fields.forEach((field) => {
          const optionName = field.dataset.showIfOption;
          if (!optionName) return;
          const index = this.optionNames.indexOf(optionName);
          const visible = index !== -1 && this.currentOptions[index] === field.dataset.showIfValue;
          field.hidden = !visible;
          // 非表示中は required 検証対象外にし、disabled で値も送信させない
          field.querySelectorAll('input, select').forEach((input) => {
            input.disabled = !visible;
          });
          if (!visible) this.setFieldError(field, false);
        });
      }

      validate() {
        let firstInvalid = null;
        this.fields.forEach((field) => {
          if (field.hidden || !field.hasAttribute('data-required')) return;
          const input = field.querySelector('input, select');
          if (!input) return;
          const filled = input.type === 'checkbox' ? input.checked : input.value.trim() !== '';
          this.setFieldError(field, !filled);
          if (!filled && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) {
          firstInvalid.closest('[data-field]').scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus({ preventScroll: true });
          return false;
        }
        return true;
      }

      setFieldError(field, hasError) {
        const error = field.querySelector('.custom-input__error');
        if (error) error.hidden = !hasError;
        field.classList.toggle('custom-input__field--error', hasError);
        const input = field.querySelector('input, select');
        if (input) input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
      }
    }
  );
}
